import { classnames } from '@tailwindcss-classnames';

const itemsCenter = classnames('flex', 'items-center');
const defaultStyles = classnames('justify-start');
const chipStyles = classnames(
  'justify-center',
  'px-2',
  'py-1',
  'border',
  'rounded-md',
  'max-w-max',
  'whitespace-nowrap',
  'mr-2',
  'mb-2'
);
const lgSpace = classnames('pb-3');
export const detailsBox = (asChip: boolean, isLg: boolean): string =>
  classnames(itemsCenter, {
    [defaultStyles]: !asChip,
    [chipStyles]: asChip,
    [lgSpace]: isLg,
  });

export const shippingSection = classnames(itemsCenter);

export const iconSize = classnames(
  'w-5',
  'h-5',
  'text-nzxt-dark-grey-500',
  'dark:text-white',
  'fill-current',
  'mr-3'
);

const defaultText = classnames('text-xs');
const lgText = classnames('text-sm');
export const text = (isLg: boolean): string =>
  classnames(
    'text-nzxt-dark-grey-500',
    'dark:text-white',
    'flex',
    'items-center',
    {
      [defaultText]: !isLg,
      [lgText]: isLg,
    }
  );

export const buttonOverrides = classnames(
  'ml-1',
  'text-blue-600',
  'text-nzxt-volt-400',
  'hover:underline'
);

export const button = classnames('!font-thin');
export const modalContent = classnames('py-4');
export const heading = classnames('h6', 'pb-4', 'font-bold');
